<script>
  import { _ } from 'svelte-i18n'
  import { modals, user_subscription, subscription_email_mismatch, client_path } from '../../stores';
  import { logOutUser } from '../../services/user';
  import Modal from '../../elements/Modal.svelte'
  import Button from '../../elements/Button.svelte'

  let modal_id = 'afterRenew'

  function handleLogout() {
    logOutUser(true, $subscription_email_mismatch.subscription_email)
  }
</script>

<Modal id={modal_id} persistent={!!$subscription_email_mismatch}>
  <span slot="header">
    {$_('modals.afterRenew.title')}
  </span>
  <span class="content" slot="content">
    {#if $user_subscription.product.toLowerCase().includes('pro')}
      {$_('modals.afterRenew.content')}
    {:else}
      {$_('modals.afterRenew.contentBusiness')}
    {/if}
    {#if !!$subscription_email_mismatch}
      <div class="subscription-email-mismatch">
        {@html $_('modals.afterRenew.subscriptionEmailMismatch', { values: {
          currentEmail: $subscription_email_mismatch.current_email,
          subscriptionEmail: $subscription_email_mismatch.subscription_email
        }})}
      </div>
    {/if}
  </span>
  <span slot="footer">
    {#if $subscription_email_mismatch}
      <Button kind="accent" on:click={handleLogout}>{$_('buttons.logoutAndLogin')}</Button>
    {:else}
      <Button kind="accent" on:click={() => modals.close()}>{$_('buttons.ok')}</Button>
    {/if}
  </span>
</Modal>

<style>
  .content {
    display: block;
    margin-bottom: 3rem;
  }
  .subscription-email-mismatch :global(p) {
    margin-top: 1.5rem;
  }
  .subscription-email-mismatch :global(p.accent) {
    color: var(--c-accent-orange);
    font-family: var(--PensumSans-Bold);
  }
</style>